import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  LinearProgress,
  Switch,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import UseFetch from "../../customComponents/UseFetch";
import { FormControl, FormHelperText } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI
import { Tooltip } from "@mui/material"; //
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";
// import { all } from "core-js/fn/promise";
export default function WebCarousal() {
  const token = localStorage.getItem("token");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const roleResponse = useSelector((state) => state.login.login.role);

  const [refresh, setRefresh] = useState(false); // State to control refetch
  const [fileError, setFileError] = useState("");
  const [tableData, loading] = UseFetch(`${"/table/app_banner"}`, [refresh]);
  // const [tableData,loading] = UseFetch(`${baseUrl}${"/table/app_banner"}`, [refresh]);
  const [selectedFile, setSelectedFile] = useState(null);
  const maxSize = 2.5 * 1024 * 1024; // 2.5 MB
  const allowedExtensions = ["png", "jpg"];
  const { validatedFile, error } = useFileTypeValidator(
    selectedFile,
    allowedExtensions,
    maxSize,
  );
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setFileError("");
  };

  const handleRemoveFile = () => {
    setSelectedFile(null); // Remove the selected file
  };

  // Function to handle status change
  const handleStatusChange = async (id, newStatus) => {
    try {
      const url = `/table/app_banner/toggle/${id}`;
      // const url = `${baseUrl}/table/app_banner/toggle/${id}`;
      const response = await axiosInstance.get(
        url,
           {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const response = await axios.get(url, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Accept: "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });
      if (response.data.error == false) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }

      setRefresh(!refresh);
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };

  const handleUploadFile = async () => {
    // if (!selectedFile) return;
    if (!selectedFile) {
      setFileError("Please select an image to upload");
      return;
    }

    if (!validatedFile) {
      toast.error(error);
      return;
    }

    setFileError("");
    const formData = new FormData();
    formData.append("app_banner", validatedFile); // Append the file with the key 'web_banner'
    // console.log("FormData to be sent:", formData.get("app_banner"));
    let url = `/upload_app_banner`;
    // let url = `${baseUrl}${"/upload_app_banner"}`;
    try {
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // const response = await axios.post(url, formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     Accept: "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });
      setRefresh(!refresh);
      toast.success("banner uploaded successfully");
      setSelectedFile(null);
    } catch (error) {
      console.error("Upload Error:", error);
    }
    // finally {
    //   setSelectedFile(null);
    // }
  };
  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this post!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4d16a4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        };
        await axiosInstance.delete(`${"/bannerDelete"}/${id}`);
        // await axios.delete(`${baseUrl}${"/bannerDelete"}/${id}`, { headers });
        setRefresh(!refresh);
        toast.success("Deleted successful");
        Swal.fire("Deleted!", "Your post has been deleted.", "success");
      }
    } catch (error) {
      console.error("Error deleting the row:", error);
      toast.error("Failed to delete");
      Swal.fire("Error!", "There was a problem deleting the post.", "error");
    }
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("imageUrl", {
      header: "Image",
      size: 30,
      Cell: ({ cell }) => (
        <img
          src={cell.row.original.imageUrl??cell.row.original.image_url}
          alt="Image"
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
    }),
    columnHelper.accessor("imageUrlCopy", {
      header: "Image URL",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.imageUrl??cell.row.original.image_url);
          toast.success("Image URL copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original.imageUrl??cell.row.original.image_url}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
     columnHelper.accessor("type", {
      header: "Type",
      size: 30,

    }),
     columnHelper.accessor("target_route", {
      header: "Redirection",
      size: 30,
  
    }),
    columnHelper.accessor("active", {
      header: "Status",
      size: 30,
      Cell: ({ cell }) => {
        const isActive = cell.getValue() == 1 ? true : false;
        const rowId = cell.row.original._id;
        const handleToggle = () => {
          handleStatusChange(rowId);
        };
        return (
          <Switch
            checked={isActive} // checked when inactive (1)
            onChange={handleToggle}
            inputProps={{ "aria-label": "Status toggle" }}
          />
        );
      },
    }),
  ];

  // Conditionally add the "Delete" column
  if (roleResponse?.AppBanner?.delete === 1) {
    columns.push(
      columnHelper.accessor("delete", {
        header: "Delete",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          return (
            <Tooltip title="Delete Row">
              <IconButton onClick={() => handleDelete(rowId)}>
                <Delete />
              </IconButton>
            </Tooltip>
          );
        },
      }),
    );
  }

  columns.push(
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
  );

  return (
    <>
      <ToastContainer />
      {roleResponse?.AppBanner?.write === 1 && (
        <Card
          sx={{
            width: { xs: "100%", sm: "80%", md: "60%", lg: "80%" },
            margin: "0px auto",
            textAlign: "center",
            display:'none'
            // padding: { xs: 2, md: 3 },
          }}
        >
          <CardContent>
            <Box
              sx={{
                border: "2px dashed #d7bde2",
                borderRadius: "8px",
                padding: { xs: "20px", md: "40px" },
                backgroundColor: "#f5eef8",
                cursor: "pointer",
                transition: "0.3s",
                "&:hover": {
                  backgroundColor: "#ebdef0",
                },
                width: "100%",
              }}
              component="label"
              htmlFor="file-input"
            >
              <CloudUploadIcon sx={{ fontSize: 70, color: "#2196F3" }} />
              <Typography variant="body1" component="div" color="textSecondary">
                Browse Image to upload
              </Typography>
              <input
                id="file-input"
                type="file"
                hidden
                onChange={handleFileChange}
              />
            </Box>

            {/* <span style={{ color: "black", display: "block" }}>
                Image must be in .jpg or .png format
              </span> */}
            <FormHelperText sx={{ textAlign: "center" }}>
              Allowed file type{" "}
              {allowedExtensions.map((format) => `.${format}`).join(", ")} with
              max size {maxSize / (1024 * 1024)} MB
            </FormHelperText>

            {/* Upload button */}
            <Button
              variant="contained"
              color="primary"
              sx={{ marginTop: 1 }}
              onClick={handleUploadFile}
              // disabled={!selectedFile}
            >
              Upload File
            </Button>

            <FormHelperText error sx={{ textAlign: "center" }}>
              {fileError}
            </FormHelperText>

            <FormHelperText sx={{ textAlign: "center" }} error>
              {error}
            </FormHelperText>

            {/* Display selected file */}
            {selectedFile && (
              <List sx={{ marginTop: 1 }}>
                <ListItem
                  sx={{
                    backgroundColor: "#f5eef8",
                    borderRadius: "8px",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    transition: "0.3s",
                  }}
                >
                  <ListItemIcon>
                    <DescriptionIcon
                      sx={{
                        fontSize: 40,
                        color: "red",
                        transition: "0.3s",
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={selectedFile.name} />
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={handleRemoveFile}
                  >
                    <CloseIcon />
                  </IconButton>
                </ListItem>
              </List>
            )}
          </CardContent>
        </Card>
      )}
      {/* table data =================================== */}
      <Box sx={{ mt: "2rem" }}>
        <CustomTable
          columns={columns}
          data={tableData}
          loading={loading}
          permissionKey="AppBanner"
        />
      </Box>
    </>
  );
}
